import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    navigator.serviceWorker.addEventListener("message", (e) => {
      if (e.data && e.data.type === "navigate" && e.data.link) window.location.assign(e.data.link);
      if (e.data && e.data.type === "sw-updated") {
        // Auto-reload once when a new service worker takes control,
        // so users on cached old UI immediately see the new build.
        if (!sessionStorage.getItem("qrewhr_sw_reloaded")) {
          sessionStorage.setItem("qrewhr_sw_reloaded", "1");
          window.location.reload();
        }
      }
    });
    // Force immediate update check
    if (reg && reg.update) reg.update().catch(() => {});
    return reg;
  } catch { return null; }
}

export async function enableBrowserPush() {
  const reg = await registerSW();
  if (!reg) throw new Error("Service workers not supported");
  if (!("PushManager" in window)) throw new Error("Push not supported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission denied");
  const { data } = await api.get("/notifications/vapid-public-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const json = sub.toJSON();
  await api.post("/notifications/subscribe", {
    endpoint: json.endpoint,
    p256dh: json.keys.p256dh,
    auth: json.keys.auth,
  });
  return sub;
}

export async function disableBrowserPush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.delete(`/notifications/subscribe?endpoint=${encodeURIComponent(sub.endpoint)}`);
    await sub.unsubscribe();
  }
}

export async function isPushSubscribed() {
  if (!("serviceWorker" in navigator)) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch { return false; }
}
